<template>
  <div class="flightoffer">
    <div class="flightoffer--pad">
      <div
        :class="`flightoffer--wrapper flightoffer--wrapper--${
          selectable ? 'selectable' : 'display'
        }`"
      >
        <div
          :class="`flightoffer--itineraries flightoffer--itineraries--${
            selectable ? 'selectable' : 'display'
          }`"
        >
          <div v-if="is_best.length > 0" class="flightoffer--picks">
            <best-pick-pill
              v-for="value in is_best"
              :key="value"
              :value="value"
            />
          </div>
          <div
            v-for="(itinerary, itinerary_index) in flight_offer.itineraries"
            :key="`${_uid}--${itinerary_index}`"
            class="flightoffer--flex flightoffer--flex--item"
          >
            <div class="flightoffer--company">
              <!-- logo -->
              <img
                :src="`https://static.vadobay.com/airlines-logos/200x100/${carrier_iata(
                  itinerary,
                )}.png`"
                :alt="carrier_iata(itinerary)"
              />
              <!-- company name -->
              <span class="small text-muted d-lg-block d-xl-block d-none">
                <span v-if="carriers[carrier_iata(itinerary)]">
                  {{ carriers[carrier_iata(itinerary)] }}
                  {{ carrier_iata(itinerary) }}
                </span>
                <span v-else>
                  {{ carrier_iata(itinerary) }}
                </span>
              </span>
            </div>
            <div
              class="flightoffer--itinerary"
              v-b-toggle="details_ref_id"
              @click="() => show_details()"
            >
              <div class="flightoffer--flex flex-grow-1">
                <div class="flightoffer__flight-pad-path-wrapper">
                  <flight-pad-endpoint
                    :info="itinerary.segments[0].departure"
                    alignment="end"
                    highlight_time
                  />
                  <flight-pad-horizontal-path :itinerary="itinerary">
                    <template #duration> </template>
                  </flight-pad-horizontal-path>
                  <flight-pad-endpoint
                    :info="
                      itinerary.segments[itinerary.segments.length - 1].arrival
                    "
                    :delta="get_itinerary_delta(itinerary)"
                    alignment="start"
                    highlight_time
                  />
                </div>
                <div class="flightoffer--bags">
                  <flight-pad-bags
                    :flight_offer="flight_offer"
                    :itinerary_index="itinerary_index"
                  />
                </div>
                <div class="flightoffer--toggle">
                  <vb-icon name="chevron_right"></vb-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectable" class="flightoffer--prices">
          <flight-pad-price-button :flight_offer="flight_offer" />
          <p
            v-if="get_availability(get_markup(flight_offer).mu_price).show_credit_alert"
            class="flightoffer--credit-warning text-center text-danger"
            v-b-popover.hover.bottom="'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'"
          >
            <vb-icon :name="'info'" :size="14" :color="sass('danger')" />
            Credito non sufficiente
          </p>
        </div>
        <flight-pad-details-modal
          :ref="details_ref_id"
          :wrapper_id="details_ref_id"
          :flight_offer="flight_offer"
          :selectable="selectable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { IdState } from "vue-virtual-scroller";
import { get_markup } from "@liveflight/utilities/flight-offer";
import { get_availability } from "@/utilities/commons";
import { getSeatsForSegment } from "@liveflight/utilities/seat-map";
import FlightPadEndpoint from "@liveflight/components/blocks/flight-pad/flight-pad-endpoint.vue";
import FlightPadBags from "@liveflight/components/blocks/flight-pad/flight-pad-bags.vue";
import FlightPadPriceButton from "@liveflight/components/blocks/flight-pad/flight-pad-price-button.vue";
import FlightPadDetailsModal from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details-modal.vue";
import FlightPadHorizontalPath from "@liveflight/components/blocks/flight-pad/flight-pad-horizontal-path.vue";
import { carrier_iata } from "./script/utilities";
import { get_day_delta, get_itinerary_delta } from "@liveflight/utilities/flight-duration";
import BestPickPill from "./best-picks/best-pick-pill.vue";

export default {
  name: "flightoffer",
  components: {
    //'included-checked-bags': IncludedCheckedBags,
    "flight-pad-endpoint": FlightPadEndpoint,
    "flight-pad-bags": FlightPadBags,
    "flight-pad-horizontal-path": FlightPadHorizontalPath,
    "flight-pad-price-button": FlightPadPriceButton,
    "flight-pad-details-modal": FlightPadDetailsModal,
    "best-pick-pill": BestPickPill,
  },
  props: {
    flight_offer: Object,
    flight_offer_index: Number,
    travelersDetails: {
      type: Array,
      default: () => [],
    },
    is_best: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    carriers() {
      try {
        const { dictionaries = {} } =
          this.$store.state.liveflight.results || {};
        return dictionaries.carriers || {};
      } catch {
        return {};
      }
    },
  },
  created() {
    this.get_markup = get_markup;
    this.get_availability = get_availability;
    this.travelers = this.travelersDetails.reduce(
      (map, traveler) => ({
        ...map,
        [traveler.id]: {
          ...traveler,
          fullName: traveler.name.firstName + " " + traveler.name.lastName,
        },
      }),
      {},
    );
  },
  mounted() {},
  data() {
    // attenzione: poiché è utilizzato all'interno di un virtual scroller, le data() sono tutte condivise tra gli items scrollabili
    // quindi vanno evitate oppure contestualizzate tramite opportuno mixin che sostituisce l'oggetto di data() con un altro scoped nell'oggetto
    // docs: https://github.com/Akryum/vue-virtual-scroller#idstate
    return {
      travelers: {},
      details_ref_id: `${this.$router.currentRoute.name}:flight-pad-details:${this.flight_offer.id}:${this.flight_offer_index}`,
    };
  },
  mixins: [
    IdState({
      // You can customize this
      idProp: (vm) => vm.flight_offer.id,
    }),
  ],
  // This replaces data () { ... }
  idState() {
    return {
      departure: {},
      arrival: {},
    };
  },
  methods: {
    getSeatsForSegment,
    carrier_iata,
    get_day_delta,
    get_itinerary_delta,
    scroll_position() {
      let el = document.getElementById("flight-" + this.flight_offer_index);
      let node = el.closest(".flight--pad-" + this.flight_offer_index);

      if (node == null) return;

      let parent = node.parentNode;

      parent.classList.toggle("b-popover");
      el.scrollIntoView();
    },
    show_details() {
      try {
        if (this.$refs && this.$refs[this.details_ref_id]) {
          this.$refs[this.details_ref_id].show_modal();
        }
      } catch (e) {
        this.log("flight-pad.show_modal");
        this.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
$cell-padding: $grid-gutter-width/4 $grid-gutter-width/2;

.flightoffer {
  $this: &;

  &--pad {
    border-radius: $border-radius-lg * 2;
    background-color: var(--white);
  }

  &--company {
    padding: $grid-gutter-width;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: $grid-gutter-width / 10;

    width: 20%;
    max-width: 280px;
    padding: $cell-padding;
    @include media-breakpoint-down(xs) {
      width: 100%;
      max-width: 100%;
      padding: 0;
      margin: 0;
    }

    span {
      text-wrap-mode: nowrap;
    }

    img {
      width: min(90px, 32vw);
    }
  }

  &--wrapper {
    @extend .content-panel !optional;
    @include font-primary-regular;
    padding: $grid-gutter-width / 3 0 $grid-gutter-width / 3 $grid-gutter-width /
      3;
    color: $text;
    font-size: $font-size-base;
    display: flex;
    width: 100%;

    &--display {
      padding: $grid-gutter-width / 3;
    }

    @include media-breakpoint-down(md) {
      padding: $grid-gutter-width / 2;
      flex-direction: column;
    }
  }
  &--itineraries {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    border-right: 1px solid $light-gray;
    &--display {
      border-right: 0px;
    }
    & > div:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }
    @include media-breakpoint-down(md) {
      border-right: 0px;
      &--selectable > div {
        padding-bottom: $grid-gutter-width / 3;
        border-bottom: 1px solid $light-gray;
      }
      &--display > div:not(:last-child) {
        padding-bottom: $grid-gutter-width / 3;
        border-bottom: 1px solid $light-gray;
      }
    }
  }
  &--itinerary-recap {
    padding: $cell-padding;
    margin-top: $grid-gutter-width/4;

    * {
      @include font-primary-regular;
    }

    &-title {
      font-size: $h5-font-size;

      @include media-breakpoint-up(lg) {
        font-size: $h3-font-size;
      }
    }
  }
  &--itinerary {
    flex: 1;
    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }
    display: flex;
    flex-wrap: wrap;
  }

  &--flex {
    display: flex;

    &--item {
      &:first-child {
        padding-bottom: 5px;
      }

      &:last-child {
        padding-top: 5px;
      }
    }

    @include media-breakpoint-down(md) {
      & > * {
        width: 100%;
      }
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &--toggle {
    width: 50px;
    //height:127px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 12px;
      height: 12px;
    }
    [role="button"],
    & > div {
      transition: $transition-base;
    }
    @at-root #{$this}--itinerary.not-collapsed & > div {
      transform: rotate(90deg);
    }

    @include media-breakpoint-down(md) {
      transform: rotate(90deg);
      @at-root #{$this}--itinerary.not-collapsed & > div {
        transform: rotate(180deg);
      }
    }
  }
  &__flight-pad-path-wrapper {
    width: 80%; //66%;
    display: flex;
    & > :first-child {
      width: 15%;
    }
    & > :last-child {
      width: 15%;
    }
    @include media-breakpoint-down(md) {
      width: 100% !important;
    }
  }
  &--bags {
    width: calc(20% - 50px); //calc(34% - 50px);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    div {
      display: flex;
      gap: 5px;
      align-items: flex-end;
    }

    @include media-breakpoint-down(md) {
      display: none;
    }
  }
  &--prices {
    position: relative;
    width: 25%;
    padding: 0 $grid-gutter-width / 3;
    max-width: 280px;
    display: flex;
    flex-wrap: wrap;
    align-content: center;

    @include media-breakpoint-down(md) {
      width: 100%;
      max-width: 100%;
    }
  }
  &--credit-warning {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    font-size: $font-size-md;
    margin: 5px 0 0 0;
  }
  &--picks {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-right: 10px;
    border-bottom: 0 !important;
    @include media-breakpoint-down(md) {
      padding-right: 0;
    }
  }
}

//nascondere elementi in altre viste:
.detail,
.checkout,
.confirm {
  .flightoffer--wrapper > div:not(:last-child) {
    border: 0 !important;
  }
}
</style>
